const footerNavEl = document.querySelector('.footer__nav');

const footerSocialsEl = document.querySelector('.footer__socials');

footerNavEl.style.display = 'none';
footerSocialsEl.style.display = 'none';

// console.log(footerNavEl);
// console.log(footerSocialsEl);
